import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import OutlinedInput from "@mui/material/OutlinedInput";
import { useState } from "react";
import { useLanguage } from "../../contexts/LanguageContext"; // 🌍 Import translations
import { useAppContext } from '../../contexts/AppContext'; // Use the UI context for error and loading handling
import createAuthService from '../../utils/AuthService'; // Use the hook for AuthService

interface ForgotPasswordProps {
  open: boolean;
  handleClose: () => void;
}

export default function ForgotPassword({ open, handleClose }: ForgotPasswordProps) {
  const { translations } = useLanguage(); // 🌍 Use translations
  const [message, setMessage] = useState("");
  const { updateAppState } = useAppContext(); // Access loading and error context

  // create auth service instance
  const AuthService = createAuthService();

  const handleSubmitForgetPassword = async (email:string) => {
    updateAppState({ loading: true });
    await AuthService.forgotPasswordAsync(email);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      PaperProps={{
        component: "form",
        onSubmit: (event: React.FormEvent<HTMLFormElement>) => {
          event.preventDefault();
          if (message) {
            handleClose();
            setMessage("");
            return;
          }
          const formData = new FormData(event.target as HTMLFormElement);
          const email = formData.get("email") as string;

          handleSubmitForgetPassword(email);
          setMessage(translations.auth.email_verification_message);
        },
        sx: { backgroundImage: "none" },
      }}
    >
      <DialogTitle>{translations.auth.reset_password}</DialogTitle>
      <DialogContent sx={{ display: "flex", flexDirection: "column", gap: 2, width: "100%" }}>
        {!message && (
          <DialogContentText>
            {translations.auth.enter_email_reset}
          </DialogContentText>
        )}
        {message && <DialogContentText>{message}</DialogContentText>}
        {!message && (
          <OutlinedInput
            autoFocus
            required
            margin="dense"
            id="email"
            name="email"
            placeholder={translations.auth.email}
            type="email"
            fullWidth
          />
        )}
      </DialogContent>
      <DialogActions sx={{ pb: 3, px: 3 }}>
        {!message && <Button onClick={handleClose}>{translations.auth.cancel}</Button>}
        <Button variant="contained" type="submit">
          {!message ? translations.auth.send_reset_link : translations.auth.close}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
